<template>
  <router-link to="/">
    <div class="project_logo">
      <img src="/logo.png" :alt="configStore.title">
      <div v-if="!collapsed" class="project_title">
        {{ configStore.title }}
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapStores } from 'pinia'
import { useConfigStore } from '@/store/modules/config'
export default {
  name: 'ProjectLogo',
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapStores(useConfigStore)
  }
}
</script>

<style lang="less" scoped>
.project_logo {
  padding: 0 12px 0 6px;
  margin-bottom: 6px;
  height: 60px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all .2s;
  img {
    width: 36px;
    height: 24px;
    margin-right: 8px;
    transition: all .2s;
  }
  .project_title {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #000;
    font-weight: 700;
    font-size: 21px;
    line-height: 22px;
  }
}
</style>